import type { Maybe } from '@vrplatform/utils';
import type { accountAssignmentType_enum } from '@vrplatform/graphql';

export const getTransactionLineType = (
  transaction_line: Maybe<{
    accountAssignmentType?: accountAssignmentType_enum | null | undefined;
    centTotal?: number | undefined;
  }>
) => {
  if (transaction_line?.accountAssignmentType === 'deposit_reserve') {
    return 'reserve' as const;
  }

  if (transaction_line?.accountAssignmentType === 'accountsReceivable') {
    if ((transaction_line.centTotal ?? 0) >= 0) {
      return 'payment' as const;
    }
    return 'refund' as const;
  }

  if (transaction_line?.accountAssignmentType === 'deposit_merchantFee') {
    return 'merchantFee' as const;
  }

  if (transaction_line?.accountAssignmentType === 'deposit_channelFee') {
    return 'channelFee' as const;
  }

  if (transaction_line?.accountAssignmentType === 'deposit_vat') {
    return 'vat' as const;
  }

  if (transaction_line?.accountAssignmentType === 'deposit_coHostPayout') {
    return 'coHostPayout' as const;
  }

  return null;
};
